/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-07-05T16:23:43.249
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getRentPropertyDeliveryEditInit,
	getRentPropertyDeliveryView
} from '@api/rentmanage/RentPropertyDelivery';

import {
listRentPropertyDeliveryItemInit,
listRentPropertyDeliveryItemByAuthorizations,
deleteRentPropertyDeliveryItem
} from '@api/rentmanage/RentPropertyDeliveryItem';

import {
listEnergyRecordItemInit,
listEnergyRecordItemByAuthorizations,
deleteEnergyRecordItem
} from '@api/rentmanage/EnergyRecordItem';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
		AdvanceQuery: cloneObj(RespCommonDef.AdvanceQuery)
	},
	actions: {
		getRentPropertyDeliveryEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentPropertyDeliveryEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentPropertyDeliveryView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentPropertyDeliveryView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
